import React from "react";

const Facebook: React.FC = () => (
<svg width="22" height="21" viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10.9005 0C5.22771 0 0.628906 4.5988 0.628906 10.2716C0.628906 15.0886 3.9454 19.1307 8.4193 20.2408V13.4106H6.3013V10.2716H8.4193V8.91904C8.4193 5.423 10.0015 3.80255 13.4339 3.80255C14.0847 3.80255 15.2076 3.93033 15.6669 4.05769V6.90293C15.4245 6.87746 15.0034 6.86472 14.4804 6.86472C12.7962 6.86472 12.1454 7.50279 12.1454 9.16145V10.2716H15.5005L14.9241 13.4106H12.1454V20.468C17.2315 19.8538 21.1725 15.5233 21.1725 10.2716C21.1721 4.5988 16.5733 0 10.9005 0Z" fill="#999999"/>
</svg>
);

export default Facebook;
